import React, { useState } from "react";
import logger from "../../../../utils/LoggerFrontend.js";
import Actions from "../../../../Actions.js";
import { ModalConfirm } from "@talentbait/shared-components";
import BaseInvoiceAddressSelector from "../../../SelfServiceCampaignCreation/Campaign__Create_InvoiceAddressSelector.jsx";
import CreateInvoiceAddressModal from "../../../SelfServiceCampaignCreation/campaign-creation/invoice-address-modal/CreateInvoiceAddressModal.jsx";

const InvoiceAddressSelectorWrapper = ({
  onSelectAddress,
  selectedInvoiceAddress,
  selectedInvoiceAddressData,
  setSelectedInvoiceAddressData,
  invoiceAddresses
}) => {
  const [currentlySelectedAddress, setCurrentlySelectedAddress] = useState(selectedInvoiceAddress);
  const [currentlySelctedAddressData, setCurrentlySelctedAddressData] = useState(
    selectedInvoiceAddressData
  );

  logger.log("InvoiceAddressSelectorWrapper", "here", {
    currentlySelctedAddressData,
    currentlySelectedAddress,
    invoiceAddresses
  });

  return (
    <div style={{ height: "300px" }}>
      <BaseInvoiceAddressSelector
        invoiceAddresses={invoiceAddresses}
        onSelectAddress={(data) => {
          const currentlySelectedAddress = invoiceAddresses.find(
            (address) => address.id === data.value
          );

          const currentlySelectedAddressData =
            currentlySelectedAddress?.addresses?.[currentlySelectedAddress?.addresses?.length - 1];

          logger.log("InvoiceAddressSelectorWrapper:onSelectAddress", "called", {
            data,
            currentlySelectedAddress
          });

          setCurrentlySelectedAddress(currentlySelectedAddress);
          onSelectAddress(currentlySelectedAddress);
          setCurrentlySelctedAddressData(currentlySelectedAddressData);
          setSelectedInvoiceAddressData(currentlySelectedAddressData);
        }}
        currentlySelectedAddress={currentlySelectedAddress}
        selectedInvoiceAddressData={currentlySelctedAddressData}
        setSelectedInvoiceAddressData={(data) => {
          setCurrentlySelctedAddressData(data);
          setSelectedInvoiceAddressData(data);
        }}
        showEmail={false}
      />
    </div>
  );
};

class InvoiceAddressManager {
  constructor(component) {
    this.component = component;
  }

  closeModal() {
    Actions.toggleModal("showGenericModal", false);
  }

  openAddressModal() {
    const { organization, companyName } = this.component.state;

    Actions.toggleModal("showGenericModal", true, {
      headline: "Neue Rechnungsanschrift einfügen",
      widthVersion: "small",
      view: (
        <div style={{ padding: 15 }}>
          <CreateInvoiceAddressModal
            onCancel={this.closeModal}
            organizationId={organization.id}
            companyName={companyName}
          />
        </div>
      )
    });
  }

  openInvoiceSelectorModal() {
    const { t } = this.component.props;
    const { invoiceAddresses, selectedInvoiceAddress, selectedInvoiceAddressData } =
      this.component.state;

    Actions.toggleModal("showGenericModal", true, {
      headline: t("Download offer"),
      widthVersion: "large",
      view: (
        <ModalConfirm
          showDescription={true}
          subtitle=""
          labelConfirm={t("Download")}
          labelReject={t("Cancel")}
          description={
            <InvoiceAddressSelectorWrapper
              onSelectAddress={this.component.onSelectAddress.bind(this.component)}
              setSelectedInvoiceAddressData={this.component.setSelectedInvoiceAddressData.bind(
                this.component
              )}
              selectedInvoiceAddress={selectedInvoiceAddress}
              selectedInvoiceAddressData={selectedInvoiceAddressData}
              invoiceAddresses={invoiceAddresses}
            />
          }
          cancelledAction={() => {
            Actions.toggleModal("showGenericModal", false);
          }}
          confirmedAction={() => {
            this.component.createQuote();
            this.closeModal();
          }}
        />
      )
    });
  }

  startDownloadFlow() {
    const { invoiceAddresses } = this.component.state;

    // If there aren't any invoice addresses then create one
    if (invoiceAddresses.length === 0) {
      return this.openAddressModal();
    }

    // Sets selected invoice address to the only values it has and creates the quote without opening any modals
    const hasOneOption = this.onlyHasOneInvoiceAddressOption();
    if (hasOneOption) {
      const invoiceAddress = invoiceAddresses[0];

      this.component.setState({
        selectedInvoiceAddress: invoiceAddresses[0],
        selectedInvoiceAddressData: invoiceAddress.addresses[0]
      });

      return this.component.createQuote();
    }

    return this.openInvoiceSelectorModal();
  }

  onlyHasOneInvoiceAddressOption() {
    const { invoiceAddresses } = this.component.state;
    return invoiceAddresses.length === 1 && invoiceAddresses?.[0]?.addresses?.length === 1;
  }
}

export { InvoiceAddressManager };
